<template>
    <div class="contact-options">
        <div class="hidden w-full flex-col border border-b-2 border-white bg-blue px-4 py-3 lg:flex">
            <div class="text-xl font-extrabold text-white">Contact Options </div>
        </div>
        
        <AgencyAdvertContactOptions 
            :user-type="userType" 
            :agency="agency"
            @contactFormSelect="
              (event) => $emit('contactOpen', { form: event.form, type: event.type, agency })
            "
        />
    </div>
</template>

<script>

import AgencyAdvertContactOptions from 'Components/AgencyAdvertContactOptions.vue';
import { mapGetters, mapState } from "vuex";

export default {
    name: 'ContactOptions',
    components: {
        AgencyAdvertContactOptions
    },
    computed: {
        ...mapState('agency', ['parameters', 'agency']),
        userType: function() {
            return this.parameters.emp_cand ? this.parameters.emp_cand : 'neither';
        }
    }
}

</script>
